export var backgroundSizeMap = {
  "contain": "contain",
  "cover": "cover",
  "default": "default"
};